import { GONDOLA_COLORS } from "@/features/sku-sections/lib/polygon-colors";
import { useState } from "react";
import { Group, Line } from "react-konva";
import { GondolaProjection } from "./gondola-projections";

export function GondolaProjectionPolygons({
  canvasDimensions,
  gondolaProjections,
  isOverflownProjectionsVisible,
  isOutsideView,
}: {
  canvasDimensions: {
    width: number;
    height: number;
  };
  isOverflownProjectionsVisible: boolean;
  gondolaProjections: GondolaProjection[];
  isOutsideView: (projection: [number, number][]) => boolean;
  isObserverCamera?: boolean;
}) {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const downscale = ([x, y]: [number, number]) =>
    [x * canvasDimensions.width, y * canvasDimensions.height] as [
      number,
      number
    ];

  return gondolaProjections.map((polygon) => {
    const downscaledPoints = polygon.projection.map(downscale);
    const isHovered = hoveredId === polygon.id;

    if (!isOverflownProjectionsVisible && isOutsideView(polygon.projection)) {
      return null;
    }

    const getFillColor = () => {
      return isHovered ? GONDOLA_COLORS.HOVER : GONDOLA_COLORS.DEFAULT;
    };

    return (
      <Group key={polygon.id}>
        <Line
          points={downscaledPoints.flatMap((point) => point)}
          fill={getFillColor()}
          closed
          opacity={0.5}
          name="gondola-projection"
          id={polygon.id}
          onMouseEnter={() => setHoveredId(polygon.id)}
          onMouseLeave={() => setHoveredId(null)}
        />
      </Group>
    );
  });
}
